enum LocationDynamicProp {
  Address = 'Address',
  City = 'City',
  StateCode = 'State/Region Code',
  StateName = 'State/Region Name',
  CountryCode = 'Country Code',
  CountryName = 'Country Name',
  Latitude = 'Lattitude',
  Longitude = 'Longitude',
  Zip = 'Zip Code',
  Radius = 'Radius',
  RadiusUnits = 'Radius Units',
}

export {LocationDynamicProp};
